import React, { useState } from "react";
import { ICard } from "../../interfaces/card";
import './style.css';

type CardProps = {
    card: ICard;
    key: number;
    htmlFor: string;
    addingToCartCallback: (value: HTMLInputElement) => void;
    setStatusCardCallback: (cardCheck: {id: number, checked: boolean}) => void
};

export function Card(props: CardProps) {
    const[check, setCheck] = useState({id: props.card.id, checked: props.card.checked});

    const checkHandler = (card:HTMLInputElement) => {
        const newValue = {id:props.card.id, checked: card.checked};
        setCheck(newValue);
        props.setStatusCardCallback(newValue);
        props.addingToCartCallback(card);
    }

    return (
        <label htmlFor={props.htmlFor}>
            <input
                checked = {check.checked}
                type="checkbox"
                id={`${props.card.id}`}
                className='checkboxCard'
                onChange={e => checkHandler(e.target)}
            />
            <div className="card">
                <h3 className="card-title"><span>{props.card.title}</span></h3>
                <div className="card-image-wrapper">
                    <img className="card-image" src={props.card.image} alt=""></img>
                </div>
                <h3 className="card-price"><b>Price:</b> ${props.card.price}</h3>
                <img className="card-cart-image" src="./img/cart.svg"></img>
                <div className="card-info">
                    <p><b>Count: </b>{props.card.rating.count}</p>
                    <p><b>Rate: </b>{props.card.rating.rate}</p>
                    <p><b>Category: </b>{props.card.category}</p>
                    <p className="card-description"><b>Description: </b>{props.card.description}</p>
                </div>
            </div>
        </label>
    );
}